import { render, staticRenderFns } from "./ItemPesquisa.vue?vue&type=template&id=1c81df88&scoped=true&"
import script from "./ItemPesquisa.vue?vue&type=script&lang=js&"
export * from "./ItemPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./ItemPesquisa.vue?vue&type=style&index=0&id=1c81df88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81df88",
  null
  
)

export default component.exports